<template>
  <div>
    <div class="lg:flex bg-color md:items-center md:w4/5 md:m-auto">
      <div class="basis-2/6 sr-only lg:not-sr-only">
        <img src="@/assets/img1.png" />
      </div>
      <div class="basis-2/6">
        <div>
          <h1 class="text-2xl lg:text-4xl font-bold">
            صفقات الحب؟ جئت إلى المكان الصحيح
          </h1>
          <p class="mt-4">يبحث ملحق Honey تلقائيًا عن كوبونات</p>
          <p>على أكثر من 30000 موقع حول العالم.</p>
          <div class="mt-4">
            <div class="flex m-auto w-2/5 lg:w-3/5">
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-700"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>First star</title>
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                ></path>
              </svg>
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-700"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Second star</title>
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                ></path>
              </svg>
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-700"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Third star</title>
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                ></path>
              </svg>
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-700"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Fourth star</title>
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                ></path>
              </svg>
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-700 dark:text-gray-500"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Fifth star</title>
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                ></path>
              </svg>
              <p class="mr-3 text-sm">168،253 تقييمًا لمتجر Chrome</p>
            </div>
          </div>
        </div>
        <div class="flex justify-center mt-8">
          <div class="mb-3 xl:w-96">
            <div
              class="input-group relative flex flex-wrap items-stretch w-full mb-4"
            >
              <input-search></input-search>

              <!-- </router-link> -->
            </div>
          </div>
        </div>
        <img class="w-4/5 m-auto" src="@/assets/intl-v2-hero-laptop.png" />
        <h3>قم بالتمرير لمزيد من طرق الحفظ. إنه نوع من شئنا.</h3>
      </div>
      <div class="basis-2/6 sr-only lg:not-sr-only">
        <img src="@/assets/index.png" />
      </div>
    </div>
    <!-- Another way to access assets ? -->
  </div>
</template>
<script>
import inputSearch from "./inputSearch.vue";
export default {
  data() {
    return {
      bgImg: {
        backgroundImage: `url(${require("../assets/index.png")})`,
        height: "100vh",
        width: "100vh",
      },
      search: "",
    };
  },
  components: {
    inputSearch,
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #edf1fe;
}
</style>
